import {type IDictionary} from '../../../@type/dictionary';
import {updateTranslatedModalTerms} from '../reducers/environmentReducer';
import {store} from '../store';
import {Feature} from '../reducers/environmentReducer';
import {FeatureFlag} from '../../../@type/features';

export function initLanguage() {
	const translatedModalTerms = Feature.metadata<IDictionary>(FeatureFlag.TRANSLATED_MODAL_TERMS, 'selected_language');
	store.dispatch(updateTranslatedModalTerms(translatedModalTerms ?? {}));
}
